var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsumables(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2187 5.70861C20.8676 5.24501 20.3813 5 19.8125 5C18.5473 5 17.5547 6.69982 16.9988 7.84077L14.647 6.78352C13.0101 6.04835 11.0744 6.01053 9.35332 6.78352L7.00145 7.84077C6.44951 6.70785 5.45207 5 4.1878 5C3.61894 5 3.1327 5.24504 2.78157 5.70861C1.9594 6.79406 2.00034 8.99359 2.00034 10.4784C2.00034 12.2657 2.76903 13.9303 4.22334 15.2922C5.22649 16.2317 6.22834 16.7216 6.40076 16.8022C6.76376 16.9961 5.20266 16.1736 9.35329 18.3505C11.0524 19.2409 13.0423 19.1918 14.6469 18.3505C18.818 16.1629 17.2243 17.0024 17.5995 16.8022C17.7719 16.7215 18.7738 16.2316 19.7769 15.2922C21.2312 13.9303 21.9999 12.2657 21.9999 10.4784C22 8.9186 22.0263 6.77473 21.2187 5.70861V5.70861ZM3.25031 10.4783C3.25031 8.98921 3.25031 6.21738 4.1878 6.21738C4.34553 6.21738 4.7706 6.47323 5.36348 7.4321C5.70495 7.98439 5.96319 8.54729 6.06276 8.77426V15.1897C4.96821 14.4459 3.25031 12.8936 3.25031 10.4783ZM17.9375 15.1897V8.77426C18.0371 8.54733 18.2953 7.98439 18.6368 7.4321C19.2297 6.47323 19.6548 6.21738 19.8125 6.21738C20.75 6.21738 20.75 8.98921 20.75 10.4783C20.75 12.4705 19.5877 14.0702 17.9375 15.1897Z",
    fill: "#24CA49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumables);
export default __webpack_public_path__ + "static/media/consumables.463999fd58c65acb86bd90bb259c1c01.svg";
export { ForwardRef as ReactComponent };